import { AfterViewInit, Directive, ElementRef, Input } from "@angular/core";
import { UtilService } from "common/util.service";

@Directive({ selector: "[stagesScrollIntoView]" })
export class ScrollIntoViewDirective implements AfterViewInit {
	constructor(private elRef: ElementRef, private utilService: UtilService) {}

	// ff does not respect the container margins for window.innerHeight, therefore the margins have to be added manually
	@Input()
	containerBottomMargin?: number;
	@Input()
	containerTopMargin?: number;

	ngAfterViewInit(): void {
		let marginToConsider = 0;
		// ff does not respect the container margins for window.innerHeight, therefore the margins have to be added manually
		if (this.utilService.browserIsFirefox()) {
			marginToConsider =
				(this.containerBottomMargin === undefined ? 0 : this.containerBottomMargin) +
				(this.containerTopMargin === undefined ? 0 : this.containerTopMargin);
		}
		// is the element outside of the view on the top
		if (this.elRef.nativeElement.getBoundingClientRect().top < 0) {
			// scrolling the element to the top of the view
			this.elRef.nativeElement.scrollIntoView();
		}
		// is the element outside of the view on the bottom
		else if (this.elRef.nativeElement.getBoundingClientRect().bottom >= window.innerHeight - marginToConsider) {
			// scrolling the element to the bottom of the view
			this.elRef.nativeElement.scrollIntoView(false);
		}
	}
}
